<template>
  <div class="body">
    <ws-login title="数据采集平台登录" :bgImg="bgImg" :path="path" @refreshAuthCode="getValidateCode"
              @login="login" :smsCodeShow="smsCodeShow" :loading="logining"></ws-login>
  </div>
</template>

<script>
  import md5 from 'js-md5';
  import {login, getValidateCode, sendSms} from '@/apis/login';

  export default {
    data() {
      return {
        bgImg: this.$commonUrl.cos() + '/publicManage/images/ws-logo-type-safe.png',
        logining: false,
        path: '',
        keyCode: '',
        smsCodeShow: false
      };
    },
    created() {
      console.log(document.cookie);
      const wsKey = this.getCookies('WS_KEY');
      console.log(wsKey);
      if (wsKey) {
        this.$storage.set('user', wsKey);
        document.cookie = 'WS_KEY=null; max-age=0; domain=wsecar.com';
        this.$router.push({path: '/welcome'});
      }
    },
    mounted() {
      this.getValidateCode();
    },
    methods: {
      getCookies(name) {
        let arr,
          reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
          let result = unescape(arr[2]);
          result = result.replace(/^\"|\"$/g, '')
            .replace(/\\\"/g, '"');
          try {
            return JSON.parse(result);
          } catch (e) {
          }
          return result;
        } else {
          return null;
        }
      },
      // 获取用户验证
      async getValidateCode() {
        try {
          const data = await getValidateCode({});
          let base64Data = 'data:image/png;base64,' + JSON.parse(data.data).authCode;
          this.path = base64Data;
          this.keyCode = JSON.parse(data.data).keyCode;
        } catch (error) {
          console.log(error);
        }
      },
      handleSubmit(formName, status) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 当手机验证码框出现的时候，enter调用登录方法的时候进行拦截
            if (status) {
              if (!this.smsCodeShow) {
                this.login();
              }
            } else {
              this.login();
            }
          } else {
            return false;
          }
        });
      },
      async login(e) {
        console.log(e);
        const {password, ...ruleForm} = e;
        const data = JSON.stringify({
          ...ruleForm,
          password: password && md5(password),
          keyCode: this.keyCode
        });
        const params = {
          token: null,
          data,
        };
        this.logining = true;
        try {
          const data = await login(params);
          this.logining = false;
          if (data.code == 1) {
            this.$storage.set('user', JSON.parse(data.data));
            await this.$router.push({path: '/welcome'});
          } else if (data.code == 50) {
            this.smsCodeShow = true;
            this.$message.error(data.msg);
            this.sendSms();
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            });
            this.getValidateCode();
          }
        } catch (error) {
          this.logining = false;
          console.log(error);
        }
      },
      // 发送短信验证码
      async sendSms() {
        let params = {
          phone: this.ruleForm.loginName,
        };
        try {
          const data = await sendSms(params);
          if (data.code == 1) {
            // this.$message.success(data.msg);
          } else {
            return this.$message.error(data.msg);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    destroyed() {
      window.removeEventListener('keydown', this.keyDown, false);
    }
  };

</script>

<style scoped lang="scss">
  .body {
    width: 100%;
    height: 100%;
    // position: fixed;
    // left: 0;
    // top: 0;
    // background: url("../../assets/img/bg.jpg") no-repeat;
    // background-size: 100% 100%;
    min-width: 1200px;
    min-height: 725px;
  }

  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 200px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }

    .divIdentifyingCode {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 5;
      width: 120px; /*设置图片显示的宽*/
      height: 40px; /*图片显示的高*/
      background: #e2e2e2;
      margin: 0;
    }
  }
</style>
